import Vue from 'vue';
import Vuex from 'vuex';
import mutations from './mutations';
import * as actions from './actions';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    ui: {
      isTouchDevice: true
    },
    routes: {},
    content: {}
  },
  actions,
  mutations
});



// WEBPACK FOOTER //
// ./C:/projects/okinawa/be-okinawa/src/js/store/main.js